// extracted by mini-css-extract-plugin
module.exports = {"container":"academy_container__qa_WJ"};